export enum MethodePrelevementEau {
    Rive = 1,
    Pont,
    PiedsDansEau,
    Bateau
}
